<template lang="pug">
  .application__item
    h1.application__item-name(
      v-text="applicationName"
    )
    users-list(
      :appName="application.name"
      :users="application.users"
      :availableRoles="application.roles"
    )
    search-users-container(
      :appName="application.name"
      :application="application"
    )
</template>

<script>
import UsersList from './UsersList.vue';
import SearchUsersContainer from './SearchUsersContainer.vue';

export default {
  name: 'TheApplication',

  components: {
    UsersList,
    SearchUsersContainer,
  },

  props: {
    application: {
      type: Object,
      required: true,
    },
  },

  computed: {
    applicationName() {
      if (this.application.name === 'auth') return 'Odin';

      // Делаем первый символ прописным
      return this.application.name.split('').map((letter, index) => (index === 0 ? letter.toUpperCase() : letter)).join('');
    },
  },

};
</script>

<style lang="scss" scoped>
  .application__item {
    max-width: 1200px;
    min-width: 288px;
    margin: 0px auto 35px auto;
    padding: 30px 24px 20px 24px;
    background-color: #fff;

    @include mobile {
      margin-top: 10px;
      margin-bottom: 16px;
      padding: 16px;
    }
  }

  .application__item-name {
    font-size: 20px;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #000000;
    margin-bottom: 10px;
    text-overflow: ellipsis;
    overflow: hidden;

    @include mobile {
      margin-top: 0;
      margin-bottom: 0;
      margin-left: 4px;
      font-size: 18px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/TheApplication.vue